import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { supabase, isSupabaseConfigured } from '@/lib/supabase';
import { AuthShell, authInput, authButton, PasswordInput } from '@/components/AuthShell';
import { GoogleAuthButton, OrDivider } from '@/components/GoogleAuthButton';

export default function Register() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!isSupabaseConfigured) return;
    setBusy(true);
    const { data, error } = await supabase.auth.signUp({
      email, password,
      options: { data: { username, display_name: username } },
    });
    if (error) { setBusy(false); toast.error(error.message); return; }
    // Email confirmation is not required: get a session immediately. If signUp
    // did not return one (depending on Supabase config), sign in right away.
    let session = data.session;
    if (!session) {
      const { data: s, error: e2 } = await supabase.auth.signInWithPassword({ email, password });
      session = s?.session;
      if (e2 && !session) {
        setBusy(false);
        toast.success('Compte créé ! Connecte-toi pour continuer.');
        navigate('/login');
        return;
      }
    }
    setBusy(false);
    toast.success('Compte créé ! Bienvenue sur MyMusic IA.');
    navigate('/');
  };

  return (
    <AuthShell title="Créer un compte" subtitle="Rejoins le studio de ton imagination."
               footer={<>Déjà inscrit ? <Link to="/login" className="text-brand hover:underline">Se connecter</Link></>}>
      <GoogleAuthButton testId="register-google" />
      <OrDivider />
      <form onSubmit={submit} className="space-y-4">
        <input required placeholder="Pseudo" value={username} onChange={(e) => setUsername(e.target.value)} className={authInput} data-testid="register-username" />
        <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={authInput} data-testid="register-email" />
        <PasswordInput required minLength={6} placeholder="Mot de passe (min 6)" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password" />
        <button type="submit" disabled={busy || !isSupabaseConfigured} className={authButton} data-testid="register-submit">
          {busy ? <Loader2 className="mx-auto h-5 w-5 animate-spin" /> : 'Créer mon compte'}
        </button>
      </form>
    </AuthShell>
  );
}
